var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout-section-container"},[_c('div',{staticClass:"field is-horizontal",attrs:{"id":_vm.identity}},[_c('div',{staticClass:"field-label"},[_c('label',{staticClass:"label is-size-5 is-size-5-5-mobile"},[_vm._v(_vm._s(_vm.label))])]),_vm._v(" "),_c('div',{staticClass:"field-body flex-column"},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32ab6ed1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/CheckoutSection.vue
// module id = null
// module chunks = 